<div class="NoDataWarpper df-c CenterData">
    <span class="CircleIcon df-c"><svg-icon class="circle df-c" src="assets/icons/files.svg"></svg-icon></span>
    <span class="body-b1 NoDataText">You have no {{selectedTab}} CCD.</span>
</div>